<template>
  <div id="forgottenPasswordComponent">
    <div class="parallelogram3" />
    <div
      class="parallelogram2 d-md-flex flex-column justify-center align-center flex-row"
      :class="{ resetActiveP2: showForgotten }"
    >
      <v-container class="unskew px-3 px-md-0">
        <v-row>
          <v-col
            cols="12"
            dense
          >
            <h3 class="whiteText pt-8">
              Enter your email to receive<br>a password reset link
            </h3>
          </v-col>
        </v-row>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center "
            >
              <v-text-field
                v-model="email"
                class="inputField mb-0"
                label="Email:"
                filled
                dark
                :rules="[...Rules.email, ...Rules.required]"
                :error-messages="emailErrors"
                @input="emailErrors = []"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="d-flex justify-end"
          >
            <v-btn
              block
              tile
              :disabled="!valid"
              :loading="loading"
              @click="reset"
            >
              Receive Link
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="d-flex justify-start"
          >
            <v-btn
              block
              tile
              outlined
              class="whiteText"
              :disabled="loading"
              @click="back"
            >
              Back
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ForgottenPasswordComponent',
  props: {
    showForgotten: {
      type: Boolean,
      default: false
    },
    candidate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    email: '',
    emailErrors: []
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    back () {
      this.redirect()
    },
    reset () {
      this.emailErrors = []

      if (!this.$refs.form.validate()) return

      this.loading = true

      const url = this.candidate
        ? this.URLs.core.auth.candidates.forgottenPassword
        : this.URLs.core.auth.forgottenPassword

      axios.post(url, { email: this.email })
        .then(() => {
          this.$emit('reset', this.email)
          this.$refs.form.reset()
          this.redirect()
        })
        .catch(error => {
          const response = error.response

          if (
            response &&
            response.status === 422 &&
            response.data.errors &&
            response.data.errors.email
          ) {
            this.emailErrors = response.data.errors.email
          } else {
            this.emailErrors = [
              'Unable to send the reset link. Please try again.'
            ]
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    redirect () {
      window.location.href = '/login'
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';

html, body, #app, .v-application {
  height: auto !important;
  min-height: 100%;
  overflow-y: auto !important;
}
#loginBackgroundComponent img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* 1) Neutralise the old "parallelogram" sizing completely */
#loginBackgroundComponent > .thing > .parallelogram-container > .parallelogram {
  position: static !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;

  width: auto !important;
  height: auto !important;
  min-height: 0 !important;

  margin: 0 !important;
  transform: none !important;
  // background: none !important;
  box-shadow: none !important;
}

/* 2) Proper layout: center the panel and give it sensible widths */
#loginBackgroundComponent .parallelogram-container {
  position: relative;
  display: flex;                 /* centers child */
  align-items: center;           /* vertical center on tall screens */
  justify-content: center;       /* horizontal center */
}

#loginBackgroundComponent .parallelogram {
  background-color: $agencyColorPrimary;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  border-radius: 12px;

  /* Responsive width & padding */
  width: min(92vw, 560px);       /* phones/tablets */
  padding: clamp(16px, 3vw, 32px);
  margin: 24px auto;             /* center on very small screens */
  overflow: hidden;              /* tidy corners if inner container overflows */
}

/* Make the row fill the viewport height on md+ so centering is true vertical */
@media (min-width: 960px) {
  #loginBackgroundComponent .thing { min-height: 100vh; }

  #loginBackgroundComponent .parallelogram-container {
    min-height: 100vh;           /* ensures vertical centering within the column */
  }

  #loginBackgroundComponent .parallelogram {
    width: min(46vw, 560px);     /* fits nicely within the md=6 (50%) column */
    margin: 0;                   /* flex container is doing the centering */
  }
}

/* Optional polish: inner v-container padding often fights our padding */
#loginBackgroundComponent .parallelogram .v-container {
  padding: 0 !important;
}

#forgottenPasswordComponent {
  .whiteText{
    color: white;
  }
  .error--text{
    color: $agencyColorDark !important
  }
  .v-input__slot {
    background: $agencyColorPrimary;
  }
  .parallelogram2 {
    position: fixed;
    bottom: -80vh;
    left: 0;
    width: 100vw;
    height: 80vh;
    background-color: $agencyColorSecondary;
    // transform: skewY(10deg);
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    transition: bottom 0.4s ease-out;
  }
  .resetActiveP2 {
    bottom: -15%;
    left: 0;
  }
  .parallelogram3 {
    position: fixed;
    bottom: -10%;
    left: 0;
    width: 100vw;
    height: 15vh;
    background-color: $agencyColorTertiary;
    // transform: skewY(10deg);
  }
  .unskew {
    margin-top: 3rem;
    text-align: center;
    // transform: skewY(-10deg);
  }
  @media screen and (min-width: 960px) {
    .parallelogram2 {
      bottom: 0;
      left: -90%;
      width: 600px;
      height: 100vh;
      // transform: skewX(-15deg);
      transition: left 0.4s ease-out;
    }
    .parallelogram3 {
      bottom: 0;
      left: -40%;
      width: 20vw;
      height: 100vh;
      // transform: skewX(-15deg);
    }
    .resetActiveP2 {
      bottom: 0;
      left: -35px;
    }
    .unskew {
      margin-top: 0;
      // transform: skewx(15deg);
      max-width: 60%;
    }
  }
  @media screen and (min-width: 1200px) {
    .parallelogram2 {
      left: -95%;
      width: 52vw;
    }
    .resetActiveP2 {
      left: -5%;
    }
    .unskew {
      text-align: center;
      // transform: skewX(15deg);
      position: relative;
      left: 2.5vw;
    }
  }
}
</style>
